import { useState } from 'react';
import { useSelector } from 'react-redux';
import useAmplitude from 'utils/hooks/useAmplitude';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import { useFreezeWallet, useCloseWallet } from 'services/reactQueryHooks/wallet';
import { getWalletSupportPhoneNumber } from './helper';

const useFooterPage = () => {
  const { sendAmplitudeEvent } = useAmplitude();
  const { mutate: freezeWallet, isLoading: isFreezeLoading } = useFreezeWallet();
  const { mutate: closeWallet, isLoading: isCloseLoading } = useCloseWallet();
  const country = useSelector(state => state.user.currentCorporation?.country);
  const supportPhoneNumber = getWalletSupportPhoneNumber(country);

  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [isWalletFrozen, setIsWalletFrozen] = useState(false);
  const [isWalletClosed, setIsWalletClosed] = useState(false);
  const [isFreezeModalVisible, setIsFreezeModalVisible] = useState(false);
  const [isCloseModalVisible, setIsCloseModalVisible] = useState(false);
  const [refundNote, setRefundNote] = useState('');

  const handleToggleDetails = () => {
    setIsDetailsOpen(isOpen => !isOpen);
  };

  const handleOpenActionModal = () => {
    if (isWalletFrozen) {
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletCloseButtonClicked);
      setIsCloseModalVisible(true);
    } else {
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletFreezeButtonClicked);
      setIsFreezeModalVisible(true);
    }
  };

  const handleCancelFreezeModal = () => {
    setIsFreezeModalVisible(false);
  };

  const handleConfirmFreeze = () => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletFreezeConfirmButtonClicked);
    freezeWallet(undefined, {
      onSuccess: () => {
        setIsWalletFrozen(true);
        setIsFreezeModalVisible(false);
      },
    });
  };

  const handleCancelCloseModal = () => {
    setIsCloseModalVisible(false);
    setIsWalletClosed(false);
    setRefundNote('');
  };

  const handleConfirmClose = () => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletCloseConfirmButtonClicked);
    closeWallet(refundNote, { onSuccess: () => setIsWalletClosed(true) });
  };

  return {
    isDetailsOpen,
    isWalletFrozen,
    isWalletClosed,
    isFreezeModalVisible,
    isCloseModalVisible,
    isFreezeLoading,
    isCloseLoading,
    refundNote,
    supportPhoneNumber,
    onToggleDetails: handleToggleDetails,
    onOpenActionModal: handleOpenActionModal,
    onCancelFreezeModal: handleCancelFreezeModal,
    onConfirmFreeze: handleConfirmFreeze,
    onCancelCloseModal: handleCancelCloseModal,
    onConfirmClose: handleConfirmClose,
    onRefundNoteChange: setRefundNote,
  };
};

export default useFooterPage;
